module.exports = __webpack_public_path__ + "img/being-creative-dark.88ce12a3.svg";